import { z } from 'zod';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];

export const AddStudentSchema = z.object({
    first_name: z.string().min(1, 'The full name field is required.'),

    last_name: z.string().min(1, 'The full name field is required.'),
    gender: z.enum(['male', 'female'], {
        required_error: 'الجنس مطلوب',
    }),
    branch_id: z.string().optional(),
    notes: z.preprocess(
        (val) => (val === null || val === undefined ? '' : String(val)),
        z.string(),
    ),

    age: z.preprocess(
        (val) => {
            if (val === '' || val === null || val === undefined) return undefined;
            const num = Number(val);
            return isNaN(num) ? undefined : num;
        },
        z.number().min(1, 'The age field is required.'),
    ),

    mother_national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    mother_national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    father_national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    father_national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    emergency_numbers: z.preprocess(
        (val) => {
            if (val === '' || val === null || val === undefined) return undefined;
            if (Array.isArray(val)) return val;
            if (typeof val === 'string') {
                // If it's a comma-separated string, split it
                return val.includes(',') ? val.split(',').map((s) => s.trim()).filter(Boolean) : [val];
            }
            return undefined;
        },
        z.array(z.string()).optional(),
    ),

    phone: z
        .string()
        .min(1, 'رقم الهاتف مطلوب')
        .refine((val) => /^\d+$/.test(val), 'الرجاء إدخال أرقام فقط')
        .refine((val) => val.length >= 8 && val.length <= 15, 'يجب أن يتكون رقم الهاتف من 8 إلى 15 رقم'),


    address: z.string().min(1, 'Address is required'),
    // national_id: z    national_id.string().min(1, 'The national id number field is required.'),
    // national_id: z
    //     .string()
    //     .length(14, 'رقم الهوية الوطنية يجب أن يكون 14 أرقام')
    //     .refine((val) => /^\d+$/.test(val), 'رقnational_id_image_frontالهوية الوطنية يجب أن يحتوي على أرقام فقط'),

    national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),

    national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),

});

export type AddStudentFormValues = z.infer<typeof AddStudentSchema>;
